import { splitCamelCaseToString } from '@pesto/utils';

export interface BooleanFilterOptionLabels {
  trueLabel?: string;
  falseLabel?: string;
  allLabel?: string;
}

const SEPARATOR = '__ID_SEPARATOR__';

export const getColumnFilterKey = (id: string | number | symbol) => {
  const strId = String(id);

  return !strId.includes(SEPARATOR) ? strId : strId.split(SEPARATOR)[0];
};

export const getColumnSortKey = (id: string | number | symbol) => {
  const strId = String(id);

  return !strId.includes(SEPARATOR) ? strId : strId.split(SEPARATOR)[1];
};

export const setColumnFilterAndSortKey = (filterKey: string, sortKey: string) => filterKey + SEPARATOR + sortKey;

export const generateSelectableFilterOptions = (obj: Record<string, string | boolean>, withCount: boolean = true) => {
  return Object.entries(obj).map(([key, value]) => ({
    label: splitCamelCaseToString(String(key)) || String(key),
    value: value,
    withCount: withCount,
  }));
};

export const generateEnumFilterOptions = (
  enumObject: Record<string, string>,
  labels: Record<string, string> = {},
  withCount: boolean = true,
) =>
  Object.entries(enumObject).map(([key, value]) => ({
    label: labels[value] ?? (splitCamelCaseToString(String(key)) || String(key)),
    value,
    withCount,
  }));

export const generateBooleanFilterOptions = (labels: BooleanFilterOptionLabels = {}) => {
  const { trueLabel = 'True', falseLabel = 'False', allLabel = 'All' } = labels;

  return [
    { label: trueLabel, value: true, withCount: false, allLabel },
    { label: falseLabel, value: false, withCount: false, allLabel },
  ];
};
